import React from "react"
import { omittedNote } from "features/Dashboard/runtime/modelAdapters"

/**
 * The frame of a bar, line or pie chart: the plot fills it (Nivo measures
 * the plot box), and when the chart left rows out because they are in
 * another unit, a muted line under the plot names them. A panel of a
 * repeated tile passes no `omitted`: the grid names them once.
 * `onContextMenu` gets the right-clicks on the chart and `trace` is what
 * they open, the trace menu and panel (see `useChartTraceMenu`), which
 * both sit on the page.
 */
const ChartFrame: React.FC<{
  kind: "bar" | "line" | "pie"
  clickable?: boolean
  omitted?: string[]
  onContextMenu?: (event: React.MouseEvent) => void
  trace?: React.ReactNode
  children: React.ReactNode
}> = ({ kind, clickable, omitted = [], onContextMenu, trace, children }) => {
  const note = omittedNote(omitted)
  return (
    <div
      className={`dq-chart dq-chart--${kind}`}
      data-clickable={clickable}
      onContextMenu={onContextMenu}
    >
      <div className="dq-chart__plot">{children}</div>
      {note && (
        <p className="dq-chart__omitted" title={note}>
          {note}
        </p>
      )}
      {trace}
    </div>
  )
}

export default ChartFrame
